import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";

function MomSysUglOrderBuyerDetailStandard ( props ) {

    const {

        onSetMaterial

    } = props;

    const [grid, setGrid] = useState();
    const [ ,setApi ] = useState();
    const { t } = useTranslation ();

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler((grid, event) => {

                    if ( grid.selectedItems && grid.selectedItems[0] ) {

                        let materialInfo = grid.selectedItems[0];

                        if ( onSetMaterial ) {

                            onSetMaterial(materialInfo);

                        }

                    }

                });

                grid.itemsSourceChanged.addHandler((grid, event) => {

                    if ( grid.selectedItems && grid.selectedItems[0] ) {

                        let materialInfo = grid.selectedItems[0];

                        if ( onSetMaterial ) {

                            onSetMaterial(materialInfo);

                        }

                    }

                });

            }

        })();

    }, [grid, onSetMaterial]);

    const onGridInitialized = ( grid ) => {

        grid.selectionMode = "Row";

        setGrid(grid);

    };

    const onApiInitialized = ( api ) => {

        setApi ( api );

    };

    const onModifyViewUrl = ( url ) => {

        return "/api/MomSysZvwMaterial/forOrderBuyerDetailCreate"

    };

    return (

        <BasicCrudScreenType 
            id="MomSysZvwMaterial"
            headerTitle={t("tableName.MomSysUglOrderBuyerDetailDialog")}
            table="MomSysZvwMaterial"
            view="MomSysZvwMaterial"
            noCreate
            noEdit
            noDelete
            noExcel
            noFilter
            onApiInitialized={onApiInitialized}
            onInitialized={onGridInitialized}
            onModifyViewUrl={(url) => onModifyViewUrl(url)}
            embededInOtherScreenType
        />

    );

}

export default MomSysUglOrderBuyerDetailStandard;
